import { Flex, Text, ToggleButton } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { memo } from 'react';

import { useCustomScheduleTypeSelector } from './CustomScheduleTypeSelector.hooks';
import { messages } from './CustomScheduleTypeSelector.messages';
import { CustomScheduleTypeSelectorProps } from './CustomScheduleTypeSelector.types';

export const CustomScheduleTypeSelector = memo<CustomScheduleTypeSelectorProps>((props) => {
    const { ruleIndex } = props;

    const { value, handleChange } = useCustomScheduleTypeSelector(ruleIndex);

    return (
        <Flex container alignItems='center'>
            <Flex size={12}>
                <Text font='label' color='midnight70' fontSize='small'>
                    {messages.label}
                </Text>
            </Flex>

            <Flex size={12}>
                <ToggleButton.Group
                    name='customScheduleType'
                    size='xsmall'
                    qa='custom-schedule-type'
                    value={value}
                    onChange={handleChange}
                >
                    <ToggleButton value={domain.CustomScheduleType.Weekly}>{messages.weeklyOption}</ToggleButton>

                    <ToggleButton value={domain.CustomScheduleType.Monthly}>{messages.monthlyOption}</ToggleButton>

                    <ToggleButton value={domain.CustomScheduleType.Annually}>{messages.annuallyOption}</ToggleButton>
                </ToggleButton.Group>
            </Flex>
        </Flex>
    );
});

CustomScheduleTypeSelector.displayName = 'CustomScheduleTypeSelector';
